import(/* webpackMode: "eager" */ "/home/runner/work/shipsmart-frontend/shipsmart-frontend/apps/admin/src/app/error.tsx");
